export default "__VITE_ASSET__lRYStiz3__"